import dayjs from "dayjs";
import { IUserCall, markUserCallAsBooked } from "../../services/users.service";
import styles from "./styles.module.scss";
import IconButton from "../IconButton";
import { CalendarIcon } from "../../assets";
import { COLORS } from "../../constants";
import { useState } from "react";

type UserCallProps = {
  call: IUserCall;
  refetchUserCalls?: () => void;
};
const UserCall: React.FC<UserCallProps> = ({ call, refetchUserCalls }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleMarkAsBooked = async () => {
    try {
      setIsLoading(true);
      await markUserCallAsBooked({
        purchaseId: call.id,
        userId: call.userId,
      });
      await refetchUserCalls?.();
      console.log("mark as booked");
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.callInfo}>
        <p>
          {call.priceId === "price_1S6VjMA9qVxHukS4CTm7p2lj"
            ? "60 min meeting"
            : "30 min meeting"}
        </p>
        <span>{dayjs.utc(call.createdAt).format("DD MMM, YYYY")}</span>
      </div>
      <IconButton
        onClick={handleMarkAsBooked}
        isLoading={isLoading}
        icon={<CalendarIcon fill={COLORS.textBlack} />}
        title="Mark as booked"
        width="160px"
      />
    </div>
  );
};

export default UserCall;
